<template>
  <div v-loading="loading">
    <div id="main" class="wp clearfix">
      <div class="detailsCon fr">
        <div class="rightsCon fr" v-if="flag">
          <div class="conTop clearfix">
            <div class="crumbs">
              <a @click="gotoindex()">首页</a>
              <i>>></i>
              <a @click="gotonav()">{{ nodeName }}</a>
              <i>>></i>
              <span>正文</span>
            </div>
            <div class="conTit clearfix">
              <span>{{ name }}</span>
            </div>
          </div>
          <div class="conMain">
            <div class="textInner">
              <h2>{{ title }}</h2>
              <div class="textInfo">
                <span>更新时间： {{ dateTime }}</span>
                <i>|</i>
                <span>点击数： {{ showTimes }}次</span>
              </div>
              <div class="htmlIMG" v-html="html" style="font-size: 20px">
                {{ html }}
              </div>
            </div>
            <div class="contPosi" v-if="filesFlag">
              点击下载：
              <p v-for="(item, index) in files" :key="index">
                <a :href="item.path">{{ item.title }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GET_DETAILS_LIST } from "@/api/index";
import { mapMutations, mapGetters, mapState } from "vuex";
export default {
  name: "detail",
  data() {
    return {
      flag: false, //数据加载
      loading: false, //页面加载
      filesFlag: false,
      cid: {},
      nodeName: "",
      name: "",
      title: "",
      list: [],
      html: [],
      showTimes: 0,
      UPtime: {},
      dateTime: "",
      isFiles: false,
      files: [],
      nodeAid: null, //获取过来的aid
      nodeCid: null, //传过来的Cid,
      colunmHurl: "", //跳转的栏目路径
    };
  },
  created() {},
  mounted() {
    this.getCidAidTitle();
  },
  computed: {
    ...mapGetters(["sid", "listCid", "detailName", "clickCid", "detailTitle"]),
    ...mapState(["DepsDat"]),
  },
  methods: {
    ...mapMutations({
      set_ListCid: "SET_LISTCID",
      SET_CLICKCID: "SET_CLICKCID",
      SET_SEARCHTEXT: "SET_SEARCHTEXT",
    }),
    gotonav() {
      if (this.nodeCid == 1000) {
        this.$router.push({ name: "search" });
      } else {
        this.$router.push({ path: `/${this.colunmHurl}` });
      }
    },
    getCidAidTitle() {
      var nodeName = this.$route.params.cid; //获取params传过来的cid
      this.nodeCid = this.$route.params.cid;
      this.nodeAid = this.$route.params.aid;
      this.cid = this.$route.query;
      // 将Vuex里面的name拿到
      this.DepsDat.map((item, index) => {
        for (var i = 0; i < item.children.length; i++) {
          if (item.children[i].cid == nodeName) {
            this.nodeName = item.children[i].name;
            // console.log(item.children[i].hUrl);
            this.colunmHurl = item.children[i].hUrl;
            var data = {
              a: index,
              b: i,
            };
            this.SET_CLICKCID(data);
            this.getDetailsAid();
          }
        }
      });
    },
    getDetailsAid() {
      let Adata = {
        t: "a",
        sid: this.$store.state.sid,
        af: "abcomlkn",
        aid: this.nodeAid,
      };
      GET_DETAILS_LIST(Adata).then((res) => {
        if (res.data.linkURL == "") {
          this.title = res.data.title;
          this.list = res.data.content;
          this.showTimes = res.data.showTimes;
          this.dateTime = res.data.date;
          this.html = this.list.replace(/vsbimg/g, "img");
          this.flag = true;
          if (res.data.files != null) {
            if (res.data.files.length != 0) {
              const verifyImg = /.(jpg|jpeg|gif|bmp|png)$/i;
              var text = res.data.files[0].ext;
              // 验证
              if (verifyImg.test(text)) {
                this.filesFlag = false;
              } else {
                this.filesFlag = true;
                this.files = res.data.files;
              }
            }
          }
        } else {
          window.location.href = res.data.linkURL;
        }
      });
    },
    gotoindex() {
      this.$router.push({ name: "index" });
    },
  },
  destroyed() {},
  components: {},
  watch: {
    nodeCid() {
      this.getDetailsAid();
    },
  },
};
</script>
<style>
@import url(../../assets/css/details.css);
</style>